import { useState } from 'react';

export const useMatchForm = () => {
  const [edizioneSelezionata, setEdizioneSelezionata] = useState(null);
  const [squadreDisponibili, setSquadreDisponibili] = useState([]);
  const [squadra1, setSquadra1] = useState(null);
  const [squadra2, setSquadra2] = useState(null);
  const [tipoPartita, setTipoPartita] = useState('');
  const [fasciaPartita, setFasciaPartita] = useState('');
  const [giocatoriSquadra1, setGiocatoriSquadra1] = useState([]);
  const [giocatoriSquadra2, setGiocatoriSquadra2] = useState([]);
  const [falli1, setFalli1] = useState(0);
  const [falli2, setFalli2] = useState(0);
  const [fairPlay1, setFairPlay1] = useState(null);
  const [fairPlay2, setFairPlay2] = useState(null);
  const [isReadonly, setIsReadonly] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [partitaCorrente, setPartitaCorrente] = useState(null);

  const resetForm = () => {
    setSquadra1(null);
    setSquadra2(null);
    setTipoPartita('');
    setFasciaPartita('');
    setGiocatoriSquadra1([]);
    setGiocatoriSquadra2([]);
    setFalli1(0);
    setFalli2(0);
    setFairPlay1(null);
    setFairPlay2(null);
    setIsReadonly(false);
    setIsEditMode(false);
    setPartitaCorrente(null);
  };

  const updateGiocatore = (squadra, giocatoreId, campo, valore) => {
    const setGiocatori = squadra === 1 ? setGiocatoriSquadra1 : setGiocatoriSquadra2;
    
    setGiocatori(prev => prev.map(giocatore => 
      giocatore.id === giocatoreId 
        ? campo === 'vuoti' 
          ? { 
              ...giocatore, 
              [campo]: valore,
              ...distributeVuoti(valore || 0)
            }
          : { ...giocatore, [campo]: valore }
        : giocatore
    ));
  };

  // Helper function to distribute vuoti values according to the rules:
  // 1-3: all in vuoti1
  // 4-6: first 3 in vuoti1, remainder in vuoti2
  // 7-8: first 3 in vuoti1, next 3 in vuoti2, remainder in vuoti3
  const distributeVuoti = (totalVuoti) => {
    let vuoti1 = 0;
    let vuoti2 = 0;
    let vuoti3 = 0;
    
    if (totalVuoti >= 1) {
      vuoti1 = Math.min(totalVuoti, 3);
    }
    
    if (totalVuoti >= 4) {
      vuoti2 = Math.min(totalVuoti - 3, 3);
    }
    
    if (totalVuoti >= 7) {
      vuoti3 = totalVuoti - 6;
    }
    
    return { vuoti1, vuoti2, vuoti3 };
  };

  const toggleCartellino = (squadra, giocatoreId, tipo) => {
    const setGiocatori = squadra === 1 ? setGiocatoriSquadra1 : setGiocatoriSquadra2;
    
    setGiocatori(prev => prev.map(giocatore => 
      giocatore.id === giocatoreId 
        ? { ...giocatore, [tipo]: !giocatore[tipo] }
        : giocatore
    ));
  };

  return {
    // State
    edizioneSelezionata,
    squadreDisponibili,
    squadra1,
    squadra2,
    tipoPartita,
    fasciaPartita,
    giocatoriSquadra1,
    giocatoriSquadra2,
    falli1,
    falli2,
    fairPlay1,
    fairPlay2,
    isReadonly,
    isEditMode,
    partitaCorrente,
    
    // Setters
    setEdizioneSelezionata,
    setSquadreDisponibili,
    setSquadra1,
    setSquadra2,
    setTipoPartita,
    setFasciaPartita,
    setGiocatoriSquadra1,
    setGiocatoriSquadra2,
    setFalli1,
    setFalli2,
    setFairPlay1,
    setFairPlay2,
    setIsReadonly,
    setIsEditMode,
    setPartitaCorrente,
    
    // Actions
    resetForm,
    updateGiocatore,
    toggleCartellino
  };
};